import DefaultContainer from "components/common/DefaultContainer/DefaultContainer";
import { Fragment } from "react";

const BuyAppointment: React.FC = () => {
    return (
        <DefaultContainer
            title="Buy Appointment"
            body={
                <Fragment>
                    <p>Need to buy an appointment ? Here you are !</p>
                    <div className="flex-row align-items-stretch flex-wrap flex-gap-col flex-gap-row">
                        <div className="clickable shadow">
                            <img />
                            <p>Appointment with Doctor</p>
                        </div>
                        <div className="clickable shadow">
                            <img />
                            <p>Appointment with Nutritionist</p>
                        </div>
                    </div>
                </Fragment>
            }
        />
    )
}

export default BuyAppointment;